export default __webpack_public_path__ + "static/media/empty-state-campaigns.0b2bdcfd.png";